import { HOLIDAYS } from "../actions/utilities";

const INITIAL_STATE = {
    getHolidaysLoading: false,
    getHolidaysSuccess: false,
    getHolidaysFailure: false,
    getHolidaysError: null,
    holidayList: []
}

export const holidayReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case HOLIDAYS.GET_ALL_HOLIDAYS_REQUEST:
            return {
                ...state,
                getHolidaysLoading: true,
                getHolidaysSuccess: false,
                getHolidaysFailure: false,
                getHolidaysError: null,
            }
        case HOLIDAYS.GET_ALL_HOLIDAYS_SUCCESS:
            return {
                ...state,
                getHolidaysLoading: false,
                getHolidaysSuccess: true,
                getHolidaysFailure: false,
                getHolidaysError: null,
                holidayList: action.payload
            }
        case HOLIDAYS.GET_ALL_HOLIDAYS_FAILURE:
            return {
                ...state,
                getHolidaysLoading: false,
                getHolidaysSuccess: false,
                getHolidaysFailure: true,
                getHolidaysError: action.payload,
            }
        default:
            return state;
    }
}
